import {
  useIsMobile,
  WSBadge,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSLoader,
  WSSwitchInput,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  SubscriptionPackage,
  SubscriptionPackageTier,
  SubscriptionTerm
} from "@wingspanhq/users/dist/lib/interfaces";
import * as React from "react";
import { CertifiedSecureDigitalPayments } from "../../../components/CertifiedSecureDigitalPayments/CertifiedSecureDigitalPayments";
import { useUserId } from "../../../query/hooks/helpers";
import { useSubscriptionPackages } from "../../../query/subscriptions/queries";
import { useUserProfile } from "../../../query/users/queries";
import { WSQueries } from "../../../query/WSQuery";
import { IGCSSubscriptionPackageTier } from "../../../services/users";
import { FREE_TRIAL_DAYS } from "../../../Settings/components/MembershipPackages/subscriptionPackages";
import { SubscriptionForm } from "./SubscriptionForm";
import styles from "./SubscriptionWidget.module.scss";

interface SubscriptionWidgetProps extends WSElementProps {}

export const SubscriptionWidget: React.FC<SubscriptionWidgetProps> = props => {
  const [payAnnually, setPayAnnually] = React.useState<boolean>(true);
  const userId = useUserId();
  const qSubscriptionPackages = useSubscriptionPackages();
  const qUser = useUserProfile(userId);
  const isMobile = useIsMobile();

  const onTogglePaymentFrequency = (value: any) => {
    setPayAnnually(value);
  };

  return (
    <WSQueries
      queries={{ qSubscriptionPackages, qUser }}
      renderLoader={() => <WSLoader.Spinner />}
    >
      {({
        qSubscriptionPackages: { data: subscriptionPackagesWithAmount }
      }) => {
        const starterBasicPackage = subscriptionPackagesWithAmount[
          SubscriptionPackage.Essentials
        ][SubscriptionPackageTier.Basic] as IGCSSubscriptionPackageTier;
        const packageTerm = payAnnually
          ? SubscriptionTerm.Yearly
          : SubscriptionTerm.Monthly;
        const { amount } = starterBasicPackage[packageTerm];
        return (
          <>
            <WSElement className={styles.subscriptionWidget}>
              <WSFlexBox
                p="M"
                justify="space-between"
                className={styles.planInfo}
                direction={isMobile ? "column" : "row"}
              >
                <WSElement mb={isMobile ? "M" : undefined}>
                  <WSText.Heading3 mb="XS">
                    Free for {FREE_TRIAL_DAYS} days.
                  </WSText.Heading3>
                  <WSText.Paragraph>
                    Just ${payAnnually ? amount / 12 : amount}/month after that.
                  </WSText.Paragraph>
                </WSElement>
                <WSFlexBox
                  direction={isMobile ? "row" : "column"}
                  alignItems={isMobile ? "center" : "flex-end"}
                >
                  <WSFlexBox.CenterY
                    mr={isMobile ? "S" : undefined}
                    mb={isMobile ? undefined : "XS"}
                  >
                    <WSSwitchInput
                      name="payAnnually"
                      value={payAnnually}
                      onChange={onTogglePaymentFrequency}
                    />
                    <WSText.Label ml="S">Pay Annually</WSText.Label>
                  </WSFlexBox.CenterY>
                  {payAnnually && (
                    <WSBadge
                      backgroundColor="green100"
                      textProps={{ color: "green500" }}
                      text="Save 33%"
                    />
                  )}
                </WSFlexBox>
              </WSFlexBox>
              <SubscriptionForm packageTerm={packageTerm} />
            </WSElement>
            <WSFlexBox.Center p="M">
              <WSText.ParagraphSmall
                color="grey700"
                className={styles.widgetFooter}
              >
                If you don't love Wingspan after 3 months, we'll refund you. No
                questions asked.
              </WSText.ParagraphSmall>
            </WSFlexBox.Center>
            <CertifiedSecureDigitalPayments withTooltip />
          </>
        );
      }}
    </WSQueries>
  );
};
